<template>
  <div class="Productservices">
    <div class="banner-backgroud">
      <div class="banner-ProductService-title">
        <p class="ProductService-firsttitle">互联网+教育 Internet+ Education 教育行业解决方案专家</p>
        <p class="ProductService-censenttitle">专业高效 让互联网推动教育行业创新发展</p>
      </div>
    </div>
    <!-- banner start -->
    <!-- 产品及服务 start -->
    <div class="ProductService">
      <p class="ProductService-title">产品及服务</p>
      <p class="ProductService-title-english">PRODUCTS AND SERVICES</p>
      <p class="green-line"></p>
      <el-row>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-for="(item ,index) in productsList" :key='item.index' style="margin-right: 10px;">
          <div class="ProductService-itembox">
            <div class="ProductService-itembox-image">
              <img :src="item.picture" />
            </div>
            <div class="ProductService-itembox-content">
              <p class="itembox-content-name">{{item.name}}</p>
              <p class="itembox-content-text">{{item.description}}</p>
              <div class="green-right">
                <i class="el-icon-arrow-right"></i>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 产品及服务 end -->
    <!-- botton start -->
    <div class="product-bntbox">
      <el-button round @click="SelectContact()">了解更多<i class="el-icon-arrow-right"></i></el-button>
    </div>
    <!-- botton end -->
    <!-- 底部引入 -->
    <FooderContent></FooderContent>
  </div>

</template>

<script>
  import FooderContent from '../components/fooder.vue'
  import {list} from '../../api/index.js'
  import {url} from '../../config/config.js'
  export default {
    components: {
      FooderContent
    },
  	created() {
  		//产品与服务
  		list().then(res=>{
  		  res.data.data.map(productsList=>{
  			productsList.picture = url + productsList.picture
  		  })
  		  this.productsList=res.data.data
  		  console.log(this.productsList)
  		})
  		.catch(err=>{
  		  alert('错误信息'+err.msg)
  		})
  	},
    methods:{
      /* 联系我们 */
      SelectContact() {
      	this.$router.push({
      		path: '/Contactus#dwon'
      	})
      }
    },
    data() {
      return {
        Productlist: [],
  		productsList:[],
      }
    }
  }
</script>

<style>
  .banner-backgroud {
  	width: 100%;
  	min-width: 118rem;
  	height: 668px;
  	background-image: url(../assets/productservice/bijiben.jpg);
  	background-size: cover
  }

  .banner-ProductService-title {
  	width: 30.625rem;
  	overflow: auto;
  	margin: 0 auto
  }

  .ProductService-firsttitle {
  	font-size: 49px;
  	line-height: 73px;
  	opacity: 1;
  	margin-top: 10.625rem;
  	margin-bottom: 0
  }

  .ProductService-censenttitle,
  .ProductService-firsttitle {
  	font-family: Source Han Sans SC;
  	font-weight: 400;
  	color: #fff;
  	text-align: center
  }

  .ProductService-censenttitle {
  	font-size: 26px;
  	line-height: 120px;
  	opacity: .66;
  	margin-top: 1.75rem !important
  }

  .ProductService {
  	width: 90%;
  	overflow: auto;
  	margin: 0 auto
  }

  .ProductService-title {
  	font-size: 2.25rem;
  	font-family: SourceHanSansSC-Medium;
  	color: #333;
  	text-align: center;
  	margin-top: 7rem;
  	margin-bottom: .5rem
  }

  .ProductService-title-english {
  	font-size: 1.125rem;
  	font-family: Source Han Sans SC;
  	color: #999;
  	text-align: center;
  	margin-bottom: 1.5625rem
  }

  .green-line {
  	background-color: #049e04
  }

  .ProductService-itembox {
  	width: 95%;
  	height: 25.143125rem;
  	-webkit-box-shadow: 0 3px 6px rgba(0, 0, 0, .16);
  	box-shadow: 0 3px 6px rgba(0, 0, 0, .16);
  	margin-top: 3.5625rem
  }

  .ProductService-itembox-image {
  	width: 100%;
  	height: 15.625rem;
  	overflow: hidden
  }

  .ProductService-itembox-image img {
  	width: 100%;
  	height: 100%;
  	background-size: 100%;
  	-webkit-transition: all .5s linear;
  	transition: all .5s linear
  }

  .ProductService-itembox-image :hover {
  	cursor: default;
  	-webkit-transform: scale(1.2);
  	transform: scale(1.2)
  }

  .ProductService-itembox-content {
  	width: 100%;
  	height: 9.5rem;
  	position: relative;
  	margin-top: 0
  }

  .ProductService-itembox-content :hover {
  	-webkit-transform: translateY(-8px);
  	transform: translateY(-8px);
  	-webkit-transition: -webkit-transform .6s;
  	transition: -webkit-transform .6s;
  	transition: transform .6s;
  	transition: transform .6s, -webkit-transform .6s
  }

  .itembox-content-name {
  	font-size: 1.5rem;
  	font-family: Source Han Sans SC;
  	font-weight: 500;
  	line-height: 1.25rem;
  	color: #39ab6d;
  	opacity: 1;
  	margin: 0 0 .625rem 1.1875rem;
  	padding-top: 1rem
  }

  .itembox-content-text {
  	font-size: 16px;
  	font-family: Source Han Sans SC;
  	font-weight: 400;
  	line-height: 24px;
  	color: #333;
  	margin: 0 1.5rem
  }

  .green-right {
  	width: 3.30125rem;
  	height: 3.435625rem;
  	background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADUAAAA3CAYAAACsLgJ7AAAABHNCSVQICAgIfAhkiAAAAkJJREFUaEPd2L1OG0EUhuHvWyBB/EQKFemggzaR6KBP+oQqHeA1ElWQoIs7ULwGiY6kRkgUKSxir0FCooCea6DgHkDsRGsDQoCxdz1ndmZ9AZYeneOZ8Uvk6FNSJe8qHF1jbkxKsdDY2gUwkxtUIaz8JrCogItcoAphZZPAWrx1uUD59UoJxM/7n5HzKL8erIPceHwuOI0qhsGCAv88PeicRTVBCrsgvVyg/LD8DYr7L4GcPCiaIHAPYH+7+9Wp9Ss2gs9KofoayKlJFcOt2QjREcHBTi8gJyYVgxRUDcBIJ5ATk1oKtz96iE67BVmPWmoEU1Q8IzDWzYSsf1HcgU4IfEgCsnZSfn17QjE6TwOyEtUC3Z4QnEw6ISvXb/nfr/HbPu+8F5BVkyoebrxX/W/OAEynnZBVk2qBBo4BfuoVZMWkvjfKw8OKp7pAmaNWajtvr73r+Okzp2NCma9fE8SbvyS+6ARlNqmvBwd9Y6OXVQlQNqhWm9snMK97Qtms311sjNucFMj4pO5joyTIKKpQr5RJrEqDjKEe19NcoF6KjdIw0b/zfhj8ABhII55+vxiqXT01ARRBdYqN0jDtqG5io1OobmOjM6gksdEJVNLYaD0qTWy0GhWDiOg4aWy0FpW2nkqDUr/9eo2N0rDE95SO2GgVSldstAalMzZagdIdGzNHScTGTFExaEixpjs2ZoaSqqfSoLb3lHRslIY9u6eaoHeXe5Kx0SzKQD2VBj1bP1OxURr2sH4mY6MRlOnYaAL1H1FpLpMS1umjAAAAAElFTkSuQmCC);
  	background-size: cover;
  	bottom: 0;
  	right: 0
  }

  .green-right,
  .green-right i {
  	float: right;
  	position: absolute
  }

  .green-right i {
  	width: .571875rem;
  	height: .97625rem;
  	right: .5625rem;
  	bottom: .4375rem;
  	color: #fff
  }

  .product-bntbox {
  	width: 100%;
  	margin: 4.4375rem 0;
  	text-align: center
  }

  @media only screen and (min-width:1200px) {
  	.ProductService .el-col-lg-8 {
  		width: 32.33333%
  	}
  }

  @media only screen and (min-width:992px) {
  	.ProductService .el-col-md-12 {
  		width: 32%
  	}
  }

  @media only screen and (max-width:768px) {
  	.ProductService .el-col-sm-12 {
  		width: 48%
  	}
  }

  @media only screen and (max-width:767px) {
  	.ProductService .el-col-xs-12 {
  		width: 46%
  	}
  }


  @media screen and (max-width: 100rem) {

    /* banner start */
    .banner-backgroud {
    	width: 100%;
    	max-width: 100%;
    	min-width: 118rem;
    	height: 30rem;
    	background-image: url(../assets/productservice/bijiben.jpg);
    	background-size: 100% 100%
    }

    .banner-ProductService-title {
    	width: 30.625rem;
    	overflow: auto;
    	margin: 0 auto
    }

    .ProductService {
    	overflow: auto;
    	margin: 0 auto
    }

    .ProductService-firsttitle {
    	font-size: 49px;
    	line-height: 73px;
    	opacity: 1;
    	margin-top: 4.625rem;
    	margin-bottom: 0
    }

    .ProductService-censenttitle,
    .ProductService-firsttitle {
    	font-family: Source Han Sans SC;
    	font-weight: 400;
    	color: #fff;
    	text-align: center
    }

    .ProductService-censenttitle {
    	font-size: 26px;
    	line-height: 120px;
    	opacity: .66;
    	margin-top: 1.75rem !important
    }

    /* banner end */
    /* 产品及服务  start */
    .ProductService-title {
    	font-size: 1.125rem !important
    }

    .ProductService-title-english {
    	font-size: .5rem !important
    }

    .green-line {
    	width: 1.5rem !important;
    	height: .125rem !important;
    	margin: 0 auto !important
    }

    .ProductService-itembox-image {
    	width: 100%;
    	height: 12rem
    }

    .ProductService-itembox {
    	width: 100%;
    	height: 21.5rem;
    	-webkit-box-shadow: 0 3px 6px rgba(0, 0, 0, .16);
    	box-shadow: 0 3px 6px rgba(0, 0, 0, .16);
    	margin-top: 3.5625rem
    }

    .ProductService {
    	width: 90%
    }

    .product-bntbox,
    .ProductService {
    	min-width: 115rem
    }
  }

  @media screen and (max-width: 62rem) {

    /* banner start */
    .banner-backgroud {
    	width: 100%;
    	max-width: 100%;
    	min-width: 100%;
    	height: 10rem;
    	background-image: url(/static/img/bijiben.c488566.jpg);
    	background-size: 100% 100%
    }

    .banner-ProductService-title {
    	width: 12rem;
    	height: 10rem;
    	margin: 0 auto
    }

    .ProductService {
    	display: inline-block;
    	height: auto;
    	max-width: 100%;
    	overflow: auto;
    	margin: 0 auto
    }

    .ProductService-firsttitle {
    	height: 3rem;
    	font-size: 1.2rem;
    	opacity: 1;
    	line-height: 1.2rem !important;
    	margin-top: 1.5rem;
    	padding: 3px 0
    }

    .ProductService-censenttitle,
    .ProductService-firsttitle {
    	font-family: Source Han Sans SC;
    	color: #fff;
    	text-align: center
    }

    .ProductService-censenttitle {
    	font-size: .03125rem !important;
    	font-weight: 400;
    	opacity: .66;
    	margin-top: 1rem !important;
    	line-height: 1rem
    }

    /* banner end */
    /* 产品及服务  start */
    .ProductService-title {
    	font-size: 1.125rem !important
    }

    .ProductService-title-english {
    	font-size: .5rem !important
    }

    .green-line {
    	width: 1.5rem !important;
    	height: .125rem !important;
    	margin: 0 auto !important
    }

    .ProductService-itembox-image {
    	width: 100%;
    	height: 12rem
    }

    .ProductService-itembox {
    	width: 100%;
    	height: 21.5rem;
    	-webkit-box-shadow: 0 3px 6px rgba(0, 0, 0, .16);
    	box-shadow: 0 3px 6px rgba(0, 0, 0, .16);
    	margin-top: 3.5625rem
    }

    .ProductService {
    	width: 90%;
    	min-width: 100%
    }

    .product-bntbox {
    	min-width: 100%
    }
  }

  /* 当屏幕小于768px时,使用媒体查询 */
  @media screen and (max-width: 48rem) {

    /* banner start */
    .banner-backgroud {
    	width: 100%;
    	height: 10rem;
    	background-image: url(../assets/productservice/bijiben.jpg);
    	background-size: 100% 100%
    }

    .banner-ProductService-title {
    	width: 12rem;
    	height: 10rem;
    	margin: 0 auto
    }

    .ProductService-firsttitle {
    	height: 3rem;
    	font-size: 1.2rem;
    	opacity: 1;
    	line-height: 1.2rem !important;
    	margin-top: 1.5rem;
    	padding: 3px 0
    }

    .ProductService-censenttitle,
    .ProductService-firsttitle {
    	font-family: Source Han Sans SC;
    	color: #fff;
    	text-align: center
    }

    .ProductService-censenttitle {
    	font-size: .03125rem !important;
    	font-weight: 400;
    	opacity: .66;
    	margin-top: 1rem !important;
    	line-height: 1rem
    }

    /* banner end */
    /* 产品及服务  start */
    .ProductService-title {
    	font-size: 1.125rem !important
    }

    .ProductService-title-english {
    	font-size: .5rem !important
    }

    .green-line {
    	width: 1.5rem !important;
    	height: .125rem !important;
    	margin: 0 auto !important
    }

    .ProductService-itembox-image {
    	width: 100%;
    	height: 12rem
    }

    .ProductService-itembox-content {
    	width: 100%;
    	min-width: 100%;
    	height: 18rem;
    	position: relative;
    	margin-top: 0
    }

    .itembox-content-name {
    	font-size: 1rem;
    	font-family: Source Han Sans SC;
    	font-weight: 500;
    	line-height: 1.25rem;
    	color: #39ab6d;
    	opacity: 1;
    	margin: 0 0 .625rem 1.1875rem;
    	padding-top: 1rem
    }

    .itembox-content-text {
    	width: 81%;
    	font-size: 15px;
    	font-family: Source Han Sans SC;
    	font-weight: 400;
    	line-height: 24px;
    	color: #333;
    	margin: 0 1.5rem
    }

    .ProductService-itembox {
    	width: 100%;
    	height: 30rem;
    	-webkit-box-shadow: 0 3px 6px rgba(0, 0, 0, .16);
    	box-shadow: 0 3px 6px rgba(0, 0, 0, .16);
    	margin-top: 3.5625rem;
    	margin-left: 6%
    }

    .ProductService {
    	width: 90%;
    	min-width: 100%
    }

    .product-bntbox {
    	min-width: 100%
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Productservices.vue